import request from "../request";

export const getAllCategory = () => {
  const url = `/category/all`;
  return request.get(url);
};

export const getCategoryByType = (type) => {
  const url = `/category?type=${type}`;
  return request.get(url);
};

export const adfsLogin = () => {
  const url = "/oauth2/login/adfs/authorize";
  return request.get(url);
};

export const getTarget = () => {
  const url = `/targetdict/all`;
  return request.get(url);
};
